import { FormProps } from 'antd/lib';
import { useMemo } from 'react';

import useFormInitialSet from '@/hooks/useFormInitialSet';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';
import { useSelectPropsWithInitial } from '@/hooks/useSelectWithInitialValue';

export const useSparePartsFilter = (formProps: FormProps, filters: any[]) => {
  const { form } = formProps;
  const initialValues: Record<string, any> = useMemo(
    () =>
      Object.fromEntries(
        filters.map(filter => {
          const valueParsed = parseInt(filter.value, 10);
          const value = isNaN(valueParsed) ? filter.value : valueParsed;

          return [filter.field, value];
        }),
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useFormInitialSet(form, initialValues, [
    {
      watchField: 'company',
      resetFields: ['company_type'],
    },
  ]);
  const { selectProps: companySelectProps } = useSelectScrollSearch(
    {
      resource: 'empresas',
      optionLabel: (item: any) => item.full_name,

      queryOptions: {
        queryKey: ['empresas'],
      },
    },
    {
      saveItem: true,
    },
  );
  const { selectProps: usersSelectProps } = useSelectScrollSearch({
    resource: 'users',
    optionLabel: (item: any) => `${item.first_name} ${item.last_name} (${item.username})`,
    pagination: {
      mode: 'off',
      pageSize: 3000,
    },
    meta: {
      empresa: 4,
    },
  });
  const companySelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: companySelectProps,
    resource: 'empresas',
    initialValue:
      initialValues.company === initialValues.shipment_payment_company
        ? [initialValues.company]
        : [initialValues.company, initialValues.shipment_payment_company],
    labelKey: 'full_name',
    valueKey: 'id',
  });
  const usersSelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: usersSelectProps,
    resource: 'users',
    initialValue: initialValues.created_by,
    labelKey: (item: any) => `${item.first_name} ${item.last_name} (${item.username})`,
    valueKey: 'id',
  });

  return {
    companySelectProps: companySelectPropsWithInitials,
    usersSelectProps: usersSelectPropsWithInitials,
  };
};
